import React, { useRef } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";

DataTable.use(DT);

const AgentsTable = ({ agents = [] }) => {
  const tableRef = useRef(null);

  const tableData = agents.map((agent) => {
    return [agent.public_id, agent.name, agent.description, ""];
  });

  return (
    <DataTable
      ref={tableRef}
      data={tableData}
      className="display"
      options={{
        responsive: true,
        select: true,
        pageLength: 25,
      }}
    >
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
    </DataTable>
  );
};

export default AgentsTable;
